<div
  class="flex justify-center items-start w-full h-[calc(100dvh-70px)] relative"
>
  <div
    class="flex flex-col justify-center w-full px-2 pb-3 pt-10 mx-auto stretch max-w-5xl h-full transition-all duration-500 ease-in-out"
    [ngClass]="{
      'w-full': !showListingsPanel,
      'w-2/5': showListingsPanel,
      'md:w-full': !showListingsPanel,
      'md:w-2/5': showListingsPanel
    }"
  >
    <div
      #messagesContainer
      class="flex flex-col min-w-0 gap-6 overflow-y-auto pt-4 relative h-auto"
      [class.flex-1]="messages.length > 0"
    >
      <ng-container *ngIf="messages.length === 0">
        <div class="flex h-full flex-col items-center justify-center">
          <div class="flex flex-col items-center gap-1.5 mb-7">
            <div class="flex items-center gap-2">
              <div
                class="flex size-12 items-center justify-center rounded-full bg-primary/10"
              >
                <!-- icon placeholder -->
              </div>
              <h1 class="text-2xl lg:text-4xl font-bold">
                Only Used Tesla AI Agent.
              </h1>
            </div>
            <p class="text-muted-foreground">
              Ask me anything about our inventory, financing, or any other
              questions you may have.
            </p>
          </div>
        </div>
      </ng-container>

      <ng-container *ngFor="let m of messages; let i = index">
        <div class="flex gap-1 items-start mb-3 h-auto">
          <div
            class="px-4 mx-auto"
            [ngClass]="
              m.role === 'user'
                ? 'bg-blue-600 max-w-xl w-fit text-white mr-1 sm:mr-4 rounded-tr-2xl rounded-s-2xl pt-2 pb-3'
                : 'shadow-b-sm ml-1 sm:ml-4 py-3 w-full'
            "
          >
            <ng-container *ngIf="m.role === 'assistant'">
              <!-- <div
                [innerHTML]="m.contentHtml || (m.content && !m.listings)"
              ></div> -->
              @if(m.listings){
              <div [innerHTML]="m.contentHtml || m.content"></div>
              <ng-container
                *ngIf="
                  m.listings && m.listings.data && m.listings.data.length > 0
                "
              >
                <div
                  class="grid md:grid-cols-2 xl:grid-cols-3 gap-4 xl:gap-x-2 2xl:gap-x-3 xl:gap-y-4 mt-4 relative mb-5"
                >
                  <ng-container
                    *ngFor="
                      let car of m.listings.data.slice(0, 6);
                      let idx = index
                    "
                  >
                    <div class="relative">
                      <out-chat-listing-card
                        [listing]="car"
                      ></out-chat-listing-card>
                      <!-- Overlay the View More card on the 6th card -->
                      <ng-container
                        *ngIf="idx === 5 && m.listings.data.length > 6"
                      >
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          [href]="m.listings.url"
                          class="absolute inset-0 z-10 flex flex-col items-center justify-center bg-white/90 hover:bg-white/95 border shadow rounded-md hover:!border-OUT-Blue transition-colors duration-300"
                        >
                          <div class="relative mb-2">
                            <img
                              src="./assets/images/icon_64x64.24a82d.png"
                              alt="Only Used Tesla Icon"
                            />
                            <div
                              class="absolute -bottom-2 -right-3 flex items-center justify-center bg-OUT-Blue text-white rounded-full size-10"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="currentColor"
                                  d="M18 12.998h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5v-5a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2"
                                  stroke-width="0.5"
                                  stroke="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <h3
                            class="font-semibold text-lg text-OUT-Blue item-end mb-3"
                          >
                            View More
                          </h3>
                        </a>
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
                <p class="font-semibold">Is there anything else you would like me to assist you with?</p>
                <div
                  *ngIf="m.listings && activeListings.loading"
                  class="grid md:grid-cols-2 xl:grid-cols-3 gap-4 xl:gap-x-2 2xl:gap-x-3 xl:gap-y-6"
                >
                  <div *ngFor="let _ of [1, 2, 3, 4, 5, 6]">
                    <out-listing-skeleton></out-listing-skeleton>
                  </div>
                </div>
              </ng-container>
              }@else if(m.createListing){
              <ng-container *ngIf="m.createListing">
                <div [innerHTML]="m.contentHtml || m.content"></div>
                @if(!m.createListing.listingCreated &&
                m.createListing.canCreateListing){
                <button
                  [disabled]="m.createListing.loading === true"
                  (click)="createListing(m)"
                  class="w-full p-2 rounded-lg bg-green-600 text-white hover:bg-green-700 transition-all duration-300 mt-2 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  @if(m.createListing.loading){
                  <div>Submitting...</div>
                  } @if(!m.createListing.loading){
                  <div>Confirm</div>
                  }
                </button>
                } @if(m.createListing.listingCreated){
                <button
                  (click)="loadListing(m)"
                  class="p-4 hover:scale-[1.02] transition-all duration-300 bg-white rounded-xl flex justify-between items-center mb-2 w-full cursor-pointer mt-2 border"
                >
                  <div class="flex gap-2 items-center">
                    <span
                      class="bg-green-100 text-green-600 p-2 rounded-full text-lg"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-check-icon lucide-check"
                      >
                        <path d="M20 6 9 17l-5-5" />
                      </svg>
                    </span>
                    <span>Listing created successfully</span>
                  </div>
                </button>
                }
              </ng-container>
              }@else{
              <div [innerHTML]="m.contentHtml || m.content"></div>
              }
            </ng-container>
            <ng-container *ngIf="m.role === 'user'">
              <div class="whitespace-pre-wrap">{{ m.content }}</div>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <div *ngIf="isLoading" class="flex gap-1 items-start mb-3 h-full">
        <div
          class="px-4 w-fit mx-auto max-w-xl bg-gray-100 ml-4 py-3 rounded-bl-2xl rounded-e-2xl"
        >
          <div class="text-sm text-gray-500">Thinking...</div>
        </div>
      </div>
    </div>

    <div class="rounded-2xl h-fit w-full md:max-w-5xl mx-auto">
      <form
        (ngSubmit)="handleSubmit()"
        (keydown.enter)="handleSubmit()"
        class="w-full rounded-2xl w-full mx-auto space-y-3 bg-white"
      >
        <div class="relative w-full h-full">
          <textarea
            name="input"
            [(ngModel)]="input"
            placeholder="Start Chat..."
            rows="2"
            class="min-h-[24px] max-h-[calc(75dvh)] overflow-hidden resize-none rounded-2xl text-base bg-muted pb-10 h-full focus:bg-black/10 border-2 focus:border-0 border-OUT-Blue focus:ring-0 flex-1 w-full p-3 focus:outline-blue-500 transition-all duration-100 ease-in-out"
          ></textarea>

          <button
            *ngIf="!isLoading"
            type="submit"
            class="rounded-full p-2 h-fit bg-blue-500 text-white disabled:bg-gray-400 transition-all absolute right-2 bottom-4 cursor-pointer"
            [disabled]="isLoading || input.length === 0"
            aria-label="Send"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                fill-rule="evenodd"
                d="M11.47 2.47a.75.75 0 0 1 1.06 0l7 6.987a.75.75 0 1 1-1.06 1.061L12.751 4.81L12.762 21a.75.75 0 0 1-1.5.002l-.01-16.194l-5.722 5.711a.75.75 0 1 1-1.06-1.061z"
                clip-rule="evenodd"
              />
            </svg>
          </button>

          <button
            *ngIf="isLoading"
            type="button"
            class="rounded-full p-2 h-fit bg-red-500 text-white transition-all absolute right-2 bottom-4 cursor-pointer"
            (click)="handleStop()"
            aria-label="Stop"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="size-5"
            >
              <rect x="6" y="6" width="12" height="12" rx="2" />
            </svg>
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- cars-display.component.html -->
  <div
    class="border-l p-2 bg-white transition-transform duration-500 ease-in-out md:relative md:w-3/5 h-full w-full md:translate-x-0 h-full overflow-y-scroll fixed z-50"
    *ngIf="showListingsPanel"
  >
    <div class="flex">
      <button
        (click)="closeListingsPanel()"
        class="border p-2 rounded-full h-9 w-9 text-sm bg-gray-100 cursor-pointer sticky top-44 z-50"
      >
        ✕
      </button>
    </div>
    @if(activeListings && panelContent === 'listings'){
    <div
      *ngIf="activeListings.data?.length"
      class="grid md:grid-cols-2 xl:grid-cols-3 gap-4 xl:gap-x-2 2xl:gap-x-3 xl:gap-y-6"
    >
      <div *ngFor="let car of activeListings.data" class="p-2 border-b">
        <out-listing-card
          [listing]="car"
          [showDescription]="false"
        ></out-listing-card>
      </div>
    </div>

    <div
      *ngIf="activeListings.loading"
      class="grid md:grid-cols-2 xl:grid-cols-3 gap-4 xl:gap-x-2 2xl:gap-x-3 xl:gap-y-6"
    >
      <div *ngFor="let _ of [1, 2, 3, 4, 5, 6, 7, 8, 9]">
        <out-listing-skeleton></out-listing-skeleton>
      </div>
    </div>

    <div *ngIf="!activeListings.loading && !activeListings.data?.length">
      <p class="text-gray-500 p-4 text-center">No cars to display</p>
    </div>

    <div
      *ngIf="
        activeListings &&
        !activeListings.loading &&
        (activeListings.data?.length || 0) < (activeListings.totalCount || 0)
      "
      class="flex justify-center p-4"
    >
      <!-- <button
        (click)="loadMoreCars()"
        class="px-4 py-2 bg-blue-600 cursor-pointer text-white rounded-md hover:bg-blue-700 transition"
      >
        Load More
      </button> -->
    </div>
    } @else if(activeListing && panelContent === 'listing'){
    <div class="px-3">
      <out-created-listing
        [listingData]="activeListing.data"
      ></out-created-listing>
      <div class="mb-5" *ngIf="activeListing.loading">
        <out-carousel-loader></out-carousel-loader>
      </div>
    </div>
    } @else{
    <p class="text-gray-500 p-4 text-center">Empty Panel</p>
    }
  </div>
</div>
